import { render, staticRenderFns } from "./expirados.vue?vue&type=template&id=021c7018&"
import script from "./expirados.vue?vue&type=script&lang=js&"
export * from "./expirados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports